module.exports = __webpack_public_path__ + "img/Disaster_apply-3.487a97ff.jpg";